import { useTheme } from '@mui/material';

export const IntroIcon6 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
        >
            <path
                d="M9.5 15.4625L20 22.6813L30.5 15.4625V12.5H9.5V15.4625ZM30.5 17.2812L20 24.5L9.5 17.2812V27.5H30.5V17.2812ZM8 27.5V16.25V12.5V11H9.5H30.5H32V12.5V16.25V27.5V29H30.5H9.5H8V27.5Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
